import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {
  fetchPayments,
  fetchPaymentsSuccess,
  fetchPaymentsFailure,
  getPayment,
  getPaymentSuccess,
  getPaymentFailure
} from "./payment.actions";
import { of } from "rxjs";
import { map, mergeMap, catchError } from "rxjs/operators";
import { PaymentnService } from "@services/payment/payment.service";

@Injectable()
export class PaymentEffects {
  loadpayments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPayments),
      mergeMap(action =>
        this.paymentnService.getPayments(action.page, action.filterOptions).pipe(
          map(res => {
            return fetchPaymentsSuccess({ payments: res });
          }),
          catchError(error => {
            return of(fetchPaymentsFailure({ error }));
          })
        )
      )
    )
  );

  loadPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPayment),
      mergeMap(action =>
        this.paymentnService.getPayment(action.paymentID).pipe(
          map(res => {
            return getPaymentSuccess({ payment: res });
          }),
          catchError(error => {
            return of(getPaymentFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private paymentnService: PaymentnService
  ) {}
}
